import axios from 'axios';
import qs from "qs"
import { baseUrl } from '../../common';



export const getNFTAddress = async(endpoint, address)=>{
    return new Promise((resolve,reject)=>{
        var config = {
            method: 'get',
            url: `https://${endpoint}/api?module=account&action=tokennfttx&address=${address}&apikey=P4RYCSQNPMV1RG9J2J7CTVBAESPQS3R4G5`,
            headers: {}
        };
        axios(config).then(function (response) {
            if(response.data.status === '1'){
                resolve(response.data.result);
            }else{
                resolve([])
            }
            
        })

    })
}

export const getTronTokenAddress = async(address)=>{
    return new Promise((resolve,reject)=>{
        var config = {
            method: 'get',
            url: `https://api.shasta.trongrid.io/v1/accounts/${address}/transactions/trc20`,
            headers: { 
              'accept': 'application/json'
            }
          };
        axios(config).then(function (response) {
            console.log(response)
            if(response.data.success){
                const data = [];
                const Arr = response.data.data;
                Arr.map((item)=>{
                    if("address" in item.token_info){
                        data.push(item)
                    }
                })
                resolve(data);
            }else{
                resolve([])
            }
        })

    })
}

export const getTokenAddress = async(endpoint, address)=>{
    return new Promise((resolve,reject)=>{
        var config = {
            method: 'get',
            url:`https://${endpoint}/api?module=account&action=tokentx&address=${address}&apikey=P4RYCSQNPMV1RG9J2J7CTVBAESPQS3R4G5`,
            headers: {}
        };
        axios(config).then(function (response) {
            if(response.data.status === '1'){
                resolve(response.data.result);
            }else{
                resolve([])
            }
        })

    })
}

export const get1155Address = async(endpoint, address)=>{
    return new Promise((resolve,reject)=>{
        var config = {
            method: 'get',
            url: `https://${endpoint}/api?module=account&action=token1155tx&address=${address}&apikey=P4RYCSQNPMV1RG9J2J7CTVBAESPQS3R4G5`,
            headers: {}
        };
        axios(config).then(function (response) {
            if(response.data.status === '1'){
                resolve(response.data.result);
            }else{
                resolve([])
            }
            
        })

    })
}

export const UniqueArr = async(Arr) => {
    return new Promise((resolve, reject) => {
      let unique = [];
      let dup = [];
      for (let i = 0; i < Arr.length; i++) {
        let test = false;
        for (let j = 0; j < Arr.length; j++) {
          if (Arr[i].address === Arr[j].address && i !== j) {
            dup.push(Arr[i]);
            test = true;
            break;
          }
        }
        if (!test) {
          unique.push(Arr[i]);
        }
      }
      resolve([unique, dup]);
    });
  }

export const uploadData = (toggleToken, erc1155, fileData) => {
    return new Promise((resolve, reject)=>{
    axios.defaults.baseURL = "https://techyroots.com:8443";
    var data = new FormData();
    let type = toggleToken ? 'Token' : erc1155 ? 'erc1155': 'erc721';
    data.append("fileupload", fileData);
    data.append("type", type);
    
    var config = {
      method: "post",
      url: `${baseUrl}/read-data`,
      headers: {
        
      },
      data: data,
    };

    axios(config)
      .then(async function (response) {
        if (response.data.success === true) {
          const validation = await UniqueArr(response.data.data);
          const Obj = {
            valid : validation[0],
            duplicate: validation[1],
            invalid : response.data.invalid,
            next : true
          }
          resolve(Obj)
        } else {
            resolve(false)
            console.error(response.msg);
        }
      })
      .catch(function (error) {
        console.error(error);
        resolve(false)
      });
    })
    
  };

// export const uploadData = (toggleToken, erc1155, fileData) => {
//     return new Promise((resolve, reject)=>{
//         const data = new FormData();
//         myHeaders.append('Access-Control-Allow-Origin', '*');
//         let type = toggleToken ? 'Token' : erc1155 ? 'erc1155': 'erc721';
//         data.append("fileupload", fileData);
//         data.append("type", type);
//         const requestOptions = {
//             method: 'POST',
//             body: data,
//             redirect: 'follow'
//           };
          
//           fetch(baseUrl+"/read-data", requestOptions)
//             .then(response => response.text())
//             .then(async(result) => {
//                 const res = JSON.parse(result)
//                 if (res.success === true) {
//                     const validation = await UniqueArr(res.data);
//                     const Obj = {
//                         valid : validation[0],
//                         duplicate: validation[1],
//                         invalid : res.invalid,
//                         next : true
//                     }
//                     resolve(Obj)
//                 } else {
//                     resolve(false)
//                     console.error(res.msg);
//                 }
//             })
//             .catch(error => reject(false));
//     })
    
//   };

export const matchTokenData = async(decimal, enterUserAmount, receiptAmount) =>{
    return new Promise(async(resolve, reject) =>{
        if(enterUserAmount*10**Number(decimal) === Number(receiptAmount)){
            resolve(true)
        }else{
            resolve(false)
        }
    })
}
export const matchNFTData = async(enterUserNftId, receiptNFT) =>{
    return new Promise(async(resolve, reject) =>{
        if(Number(enterUserNftId) === Number(receiptNFT)){
            resolve(true)
        }else{
            resolve(false)
        }
    })
}
export const match1155Data = async(enterUserNftId,enterUserNftCount, receiptNFT, receiptNFTCount) =>{
    return new Promise(async(resolve, reject) =>{
        if(Number(enterUserNftId) === Number(receiptNFT) && Number(enterUserNftCount) === Number(receiptNFTCount)){
            resolve(true)
        }else{
            resolve(false)
        }
    })
}

export const handleManualData  = async(e, web3Obj, manualEntrydata, istoken) =>{
    return new Promise(async(resolve, reject)=>{
        let data = [];
        let invalid = [];
        e.preventDefault();
        let splitted = manualEntrydata.split(/[\n,]/);    
        if(splitted.length%2 !== 0){
            splitted.pop() 
        }
        let obj = {
            address: "",
            amount : ""
        };

        for (let i = 0; i < splitted.length; i++) {
            if(i%2 === 0 ){
                let result = await web3Obj.utils.isAddress(splitted[i]);
                if(result === true){
                    if(istoken){
                        obj = {
                            address: splitted[i],
                            amount : splitted[i+1].replace(/^\s+|\s+$/gm,'')
                        };
                    }else{
                        obj = {
                            address: splitted[i],
                            id : splitted[i+1].replace(/^\s+|\s+$/gm,'')
                        };
                    }
                    data.push(obj);
                    obj = {
                        address: "",
                        amount : ""
                    };
                }else{
                    invalid.push(splitted[i])
                }  
            }   
        }
        const unique = await UniqueArr(data);
        resolve({
            valid : unique[0],
            duplicate: unique[1],
            invalid : invalid
        })
    })
    

}
export const handleTronManualData  = async(e, manualEntrydata, istoken) =>{
    return new Promise(async(resolve, reject)=>{
        let data = [];
        let invalid = [];
        e.preventDefault();
        let splitted = manualEntrydata.split(/[\n,]/);    
        if(splitted.length%2 !== 0){
            splitted.pop() 
        }
        let obj = {
            address: "",
            amount : ""
        };

        for (let i = 0; i < splitted.length; i++) {
            if(i%2 === 0 ){
                let result = await window.tronWeb.isAddress(splitted[i]);
                if(result === true){
                    if(istoken){
                        obj = {
                            address: splitted[i],
                            amount : splitted[i+1].replace(/^\s+|\s+$/gm,'')
                        };
                    }else{
                        obj = {
                            address: splitted[i],
                            id : splitted[i+1].replace(/^\s+|\s+$/gm,'')
                        };
                    }
                    data.push(obj);
                    obj = {
                        address: "",
                        amount : ""
                    };
                }else{
                    invalid.push(splitted[i])
                }  
            }   
        }
        const unique = await UniqueArr(data);
        resolve({
            valid : unique[0],
            duplicate: unique[1],
            invalid : invalid
        })
    })
    

}
export const handleTronManualData1155  = async(e, web3Obj, manualEntrydata) =>{
    return new Promise(async(resolve, reject)=>{
        let data = [];
        let invalid = [];
        e.preventDefault();
        let splitted = manualEntrydata.split(/[\n,]/); 
        let obj = {
            address: "",
            id:"",
            count : ""
        };
        for (let i = 0; i < splitted.length; i++) {
            // if(i%2 === 0 ){
                let result =await window.tronWeb.isAddress(splitted[i]);
                if(result === true){
                    obj = {
                        address: splitted[i],
                        id: splitted[i+1].replace(/^\s+|\s+$/gm,''),
                        count : splitted[i+2].replace(/^\s+|\s+$/gm,'')
                    };
                    data.push(obj);
                    obj = {
                        address: "",
                        id:"",
                        count : ""
                    };
                }else{
                    invalid.push(splitted[i])
                }  
                i = i+2;
            // }   
        }
        const unique = await UniqueArr(data);
        resolve({
            valid : unique[0],
            duplicate: unique[1],
            invalid : invalid
        })
    })
}
export const handleManualData1155  = async(e, web3Obj, manualEntrydata) =>{
    return new Promise(async(resolve, reject)=>{
        let data = [];
        let invalid = [];
        e.preventDefault();
        let splitted = manualEntrydata.split(/[\n,]/); 
        let obj = {
            address: "",
            id:"",
            count : ""
        };
        for (let i = 0; i < splitted.length; i++) {
            // if(i%2 === 0 ){
                let result = await web3Obj.utils.isAddress(splitted[i]);
                if(result === true){
                    obj = {
                        address: splitted[i],
                        id: splitted[i+1].replace(/^\s+|\s+$/gm,''),
                        count : splitted[i+2].replace(/^\s+|\s+$/gm,'')
                    };
                    data.push(obj);
                    obj = {
                        address: "",
                        id:"",
                        count : ""
                    };
                }else{
                    invalid.push(splitted[i])
                }  
                i = i+2;
            // }   
        }
        const unique = await UniqueArr(data);
        resolve({
            valid : unique[0],
            duplicate: unique[1],
            invalid : invalid
        })
    })
}

export const saveRefUser = async(address, refaddress) =>{
    return new Promise((resolve, reject)=>{
            const data = qs.stringify({
            'address': address,
            'refaddress': refaddress 
          });
          const config = {
            method: 'post',
            url: 'https://techyroots.com:8443/register',
            headers: { 
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            data : data
          };
        axios(config).then(function (response) {
            if(response.data.success){
                resolve({
                    success: true,
                    msg: response.data.msg
                })
            }else{
                resolve({
                    success: false,
                    msg: response.data.msg
                })
            }
          })
          .catch(function (error) {
            reject({
                success: false,
                msg: error.message
            })
          });
    })
}


export const fetchABI = (endpoint, address) => {
    return new Promise((resolve, reject)=>{
        var config = {
            method: 'get',
            url: `https://${endpoint}/api?module=contract&action=getabi&address=${address}&apikey=P4RYCSQNPMV1RG9J2J7CTVBAESPQS3R4G5`,
            headers: {}
        };
    
        axios(config).then((response)=>{
                if (response.data.status === "1") {
                    const abi = JSON.parse(response.data.result);
                    resolve(abi)
                }else{
                    resolve(false)
                }
            })
    })
    
}
